export default "__VITE_ASSET__6787a07b__"